function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addMonths, addYears } from 'date-fns';
import { formatDate } from '../utils';
import HeaderPanel from './headerPanel.js';
var __vue_script__ = {
  name: 'CalendarHeader',
  components: {
    HeaderPanel: HeaderPanel,
    yearMonthDay: {
      props: {
        prefixCls: String,
        value: Date,
        locale: Object,
        isTimePicker: Boolean
      },
      render: function render(h) {
        var that = this;
        var prefixCls = that.prefixCls,
            locale = that.locale,
            value = that.value,
            isTimePicker = that.isTimePicker;
        var monthSelect = locale.monthSelect,
            yearSelect = locale.yearSelect,
            _locale$monthBeforeYe = locale.monthBeforeYear,
            monthBeforeYear = _locale$monthBeforeYe === void 0 ? false : _locale$monthBeforeYe,
            yearFormat = locale.yearFormat,
            dayFormat = locale.dayFormat,
            DateFnsLocale = locale.DateFnsLocale;
        var subElements = [];
        var selectClassName = "".concat(prefixCls, "-ym-select");
        var year = h('a', {
          class: _defineProperty({}, "".concat(prefixCls, "-year-select"), true),
          attrs: {
            role: 'button',
            title: yearSelect
          },
          on: {
            click: function click(e) {
              e.stopPropagation();
              e.preventDefault();
              that.$emit('on-year-panel-click', 'date');
            }
          }
        }, formatDate(value, yearFormat, {
          locale: DateFnsLocale
        }));
        var month = h('a', {
          class: _defineProperty({}, "".concat(prefixCls, "-month-select"), true),
          attrs: {
            role: 'button',
            title: monthSelect
          },
          on: {
            click: function click(e) {
              e.stopPropagation();
              e.preventDefault();
              that.$emit('on-month-panel-click');
            }
          }
        }, formatDate(value, 'MMM', {
          locale: DateFnsLocale
        }));

        if (monthBeforeYear) {
          selectClassName = "".concat(prefixCls, "-my-select");
          subElements.push(month, year);
        } else {
          subElements.push(year, month);
        }

        if (isTimePicker) {
          var day = h('a', {
            class: _defineProperty({}, "".concat(prefixCls, "-day-select"), true),
            attrs: {
              role: 'button'
            }
          }, formatDate(value, dayFormat, {
            locale: DateFnsLocale
          }));

          if (monthBeforeYear) {
            subElements.splice(1, 0, day);
          } else {
            subElements.push(day);
          }
        }

        return h('span', {
          class: _defineProperty({}, selectClassName, true)
        }, subElements);
      }
    }
  },
  props: {
    prefixCls: String,
    locale: Object,
    mode: String,
    value: Date,
    format: String,
    hasPrev: {
      type: Boolean,
      default: true
    },
    hasNext: {
      type: Boolean,
      default: true
    },
    disabledMonth: {
      type: Function,
      default: undefined
    },
    disabledYear: {
      type: Function,
      default: undefined
    },
    isTimePicker: {
      type: Boolean,
      default: false
    },
    monthNav: {
      type: Object,
      default: function _default() {
        return {
          prev: true,
          next: true
        };
      }
    },
    yearNav: {
      type: Object,
      default: function _default() {
        return {
          prev: true,
          next: true
        };
      }
    }
  },
  data: function data() {
    return {
      yearFrom: null
    };
  },
  methods: {
    onChange: function onChange(value, originMode) {
      this.$emit('on-change', value, originMode);
      this.$emit('change', value, originMode);
    },
    onPanelChange: function onPanelChange(value, next, originMode) {
      this.$emit('on-panel-change', value, next, originMode);
      this.$emit('panel-change', value, next, originMode);
    },
    onPanelSelect: function onPanelSelect(value, next, originMode) {
      this.onPanelChange(value, next, originMode);
      this.onChange(value, originMode);
    },
    goMonth: function goMonth(direction) {
      this.onChange(addMonths(this.value, direction));
    },
    goYear: function goYear(direction) {
      this.onChange(addYears(this.value, direction));
    },
    prevYear: function prevYear() {
      this.goYear(-1);
    },
    prevMonth: function prevMonth() {
      this.goMonth(-1);
    },
    nextMonth: function nextMonth() {
      this.goMonth(1);
    },
    nextYear: function nextYear() {
      this.goYear(1);
    },
    showYearPanel: function showYearPanel(from) {
      if (this.isTimePicker) {
        return;
      }

      this.yearFrom = from;
      this.onPanelChange(null, 'year');
    },
    showMonthPanel: function showMonthPanel() {
      if (this.isTimePicker) {
        return;
      }

      this.onPanelChange(null, 'month');
    },
    showDescadePanel: function showDescadePanel() {
      this.onPanelChange(null, 'decade');
    },
    onMonthValueChange: function onMonthValueChange(value) {
      this.$emit('month-value-change', value);
    },
    onYearValueChange: function onYearValueChange(value) {
      this.$emit('year-value-change', value);
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixCls + "-header"
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm.hasPrev && !_vm.isTimePicker ? _c('a', {
    class: _vm.prefixCls + "-prev-year-btn",
    attrs: {
      "title": _vm.locale.previousYear,
      "role": "button"
    },
    on: {
      "click": _vm.prevYear
    }
  }) : _vm._e(), _vm._v(" "), _vm.hasPrev && !_vm.isTimePicker ? _c('a', {
    class: _vm.prefixCls + "-prev-month-btn",
    attrs: {
      "title": _vm.locale.previousMonth,
      "role": "button"
    },
    on: {
      "click": _vm.prevMonth
    }
  }) : _vm._e(), _vm._v(" "), _c('year-month-day', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "locale": _vm.locale,
      "value": _vm.value,
      "is-time-picker": _vm.isTimePicker
    },
    on: {
      "on-month-panel-click": _vm.showMonthPanel,
      "on-year-panel-click": _vm.showYearPanel
    }
  }), _vm._v(" "), _vm.hasNext && !_vm.isTimePicker ? _c('a', {
    class: _vm.prefixCls + "-next-month-btn",
    attrs: {
      "title": _vm.locale.nextMonth,
      "role": "button"
    },
    on: {
      "click": _vm.nextMonth
    }
  }) : _vm._e(), _vm._v(" "), _vm.hasNext && !_vm.isTimePicker ? _c('a', {
    class: _vm.prefixCls + "-next-year-btn",
    attrs: {
      "title": _vm.locale.nextYear,
      "role": "button"
    },
    on: {
      "click": _vm.nextYear
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('header-panel', {
    attrs: {
      "prefix-cls": _vm.prefixCls,
      "locale": _vm.locale,
      "mode": _vm.mode,
      "value": _vm.value,
      "year-from": _vm.yearFrom,
      "disabled-month": _vm.disabledMonth,
      "disabled-year": _vm.disabledYear,
      "month-nav": _vm.monthNav,
      "year-nav": _vm.yearNav
    },
    on: {
      "month-value-change": _vm.onMonthValueChange,
      "year-value-change": _vm.onYearValueChange,
      "on-show-year-panel": _vm.showYearPanel,
      "on-show-decade-panel": _vm.showDescadePanel,
      "on-select": _vm.onPanelSelect
    }
  })], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "calendarHeader.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);